import React, { useEffect, useState } from "react";
import { CgMenuRight, CgClose } from "react-icons/cg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";


const menuList = [
  {
    href: "",
    name: "home",
    path: "/",
  },
  {
    href: "use-cases",
    name: "use cases",
    path: "/use-cases",
  },
  {
    href: "roadmap",
    name: "roadmap",
    path: "/roadmap",
  },
  {
    href: "contact",
    name: "contact",
    path: "/contact",
  },
  // {
  //   href: "pricing",
  //   name: "pricing",
  //   path: "/pricing",
  // },
];

const Header = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = window.location.pathname;

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const user = useSelector((state) => state.user.user);
  const [isLoggedin, setIsLoggedin] = useState(false);

  useEffect(() => {
    const isAuth = user && Object.keys(user).length > 0;
    const token = localStorage.getItem("GuideproAI_user");
    const isTokenValid = !!token;
    setIsLoggedin(isAuth || isTokenValid);
  }, []);

  const HeaderMenu = () => {
    return (
      <div className="flex items-center max-lg:flex-col lg:w-full gap-10 lg:gap-3">
        <ul className="flex lg:items-center gap-6 xl:gap-50 w-full lg:justify-center max-lg:flex-col">
          {menuList.map((menu, index) => (
            <li key={index}>
              <div
                onClick={() =>
                  navigate(`${process.env.REACT_APP_HOME_PAGE}${menu.href}`)
                }
                className={`capitalize hover:font-semibold lg:w-[101px] inline-block text-center duration-200 cursor-pointer ${pathname === menu.path ? "font-semibold" : ""
                  }`}
              >
                {menu.name}
              </div>
            </li>
          ))}
        </ul>
        <button
          onClick={() => {
            if (isLoggedin) {
              navigate("/home");
            } else {
              navigate("/login");
            }
          }}
          className="btn-medium btn-primary whitespace-nowrap max-lg:w-full"
        >
          {isLoggedin ? "Go To Home" : "Get Started"}
        </button>
      </div>
    );
  };

  return (
    <div className="sticky top-0 left-0 w-full bg-white py-3 lg:py-26 z-50 lg:h-[100px]">
      <div className="container">
        <div className="flex items-center justify-between">
          <div className="logo">
            <div
              onClick={() => navigate("/")}
              className="text-lan_primary font-bold tracking-[2%] text-28 tab:text-35 cursor-pointer"
            >
              GuideProAI
            </div>
          </div>
          <div className="max-lg:hidden w-full">
            <HeaderMenu />
          </div>
          {/* Mobile Menu Toggle Button */}
          <div
            onClick={toggleMenu}
            className="lg:hidden p-2 border border-border_sec rounded-xl cursor-pointer"
          >
            <CgMenuRight className="text-xl text-gray" />
          </div>
        </div>
      </div>

      {/* Overlay */}
      <div
        className={`fixed top-0 left-0 w-full h-full bg-black/40 z-40 transition-opacity duration-300 ${isMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
        onClick={toggleMenu}
      ></div>

      {/* Mobile Sliding Menu */}
      <div
        className={`fixed top-0 right-0 w-[375px] bg-white h-full shadow-lg z-50 lg:hidden transform transition-transform duration-300 ease-in-out ${isMenuOpen ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div className="p-4 h-full">
          <div className="flex justify-end mb-4">
            <CgClose
              onClick={toggleMenu}
              className="text-2xl cursor-pointer text-gray-600"
            />
          </div>
          <HeaderMenu />
        </div>
      </div>
    </div>
  );
};

export default Header;
